(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('BundleDetailController', BundleDetailController);

    BundleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Bundle', 'Compendium', 'BillingFrequency'];

    function BundleDetailController($scope, $rootScope, $stateParams, previousState, entity, Bundle, Compendium, BillingFrequency) {
        var vm = this;

        vm.bundle = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:bundleUpdate', function(event, result) {
            vm.bundle = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
